var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationLivestream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1750_173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.01752C7.86395 2.27335 5 5.29812 5 8.99999C5 14.25 12 22 12 22C12 22 18.5687 14.7275 18.9799 9.49999H16.9732C16.6778 12.3606 14.0005 16.3416 12 18.88C9.92 16.21 7 11.85 7 8.99999C7 6.40873 8.97447 4.27583 11.5 4.02472V2.01752ZM11.5 6.55C10.3589 6.78163 9.5 7.79051 9.5 8.99999C9.5 10.3807 10.6193 11.5 12 11.5C13.2095 11.5 14.2184 10.6411 14.45 9.49999H11.5V6.55Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.179 1.10785C13.1742 1.46066 13.433 1.75452 13.7819 1.78087C16.7215 2.02763 19.0346 4.34065 19.2882 7.28017C19.318 7.63251 19.6118 7.89823 19.9646 7.8934C20.3727 7.8878 20.7027 7.53054 20.6668 7.12295C20.3562 3.53752 17.5383 0.719587 13.9495 0.405635C13.5454 0.366214 13.1847 0.692775 13.179 1.10785ZM13.1055 6.4761L13.0915 7.49302C13.0878 7.76282 13.3028 7.97775 13.5726 7.97405L14.5895 7.96012C14.9146 7.95566 15.1645 7.63754 15.0685 7.32415C14.9711 7.00889 14.7993 6.72346 14.5673 6.49149C14.3353 6.25952 14.0499 6.08769 13.7346 5.99024C13.4315 5.90448 13.1099 6.15096 13.1055 6.4761ZM13.1408 3.89574C13.1362 4.23472 13.3813 4.51494 13.7196 4.56563C14.4225 4.67668 15.0678 5.00405 15.5664 5.50263C16.065 6.00122 16.3923 6.64647 16.5034 7.34945C16.5576 7.68416 16.8343 7.93282 17.1733 7.92818L17.1802 7.92808C17.5953 7.9224 17.9393 7.55111 17.8757 7.1439C17.5752 5.09726 15.9752 3.49725 13.9251 3.19334C13.5144 3.13326 13.1466 3.47375 13.1408 3.89574Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1750_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLivestream);
export default __webpack_public_path__ + "static/media/location-livestream.504d7ce471c84a0fb112b0dc92950aea.svg";
export { ForwardRef as ReactComponent };